export default {"src":"/_next/static/media/note-dark-blue.91e4adc8.svg","height":8,"width":44,"blurWidth":0,"blurHeight":0};